import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { push } from 'connected-react-router'
import { compose } from 'recompose'
import { FormattedMessage } from 'react-intl'

import Popup from 'components/misc/Popup/Popup'
import Button from 'components/misc/Button/Button'
import config from 'config'
import activityMonitorStorage from 'helpers/activityMonitorStorage'

const timerMinutes = 180
const logoutDesicionTimeSeconds = 90

const enhance = compose(
  connect(
    ({ auth }) => ({
      user: auth.user,
      activeOrganization: auth.organization
    }),
    { push }
  )
)

class ActivityMonitor extends Component {
  static propTypes = {
    push: PropTypes.func.isRequired,
    user: PropTypes.object
  }

  state = {
    interval: null,
    displayWarning: false,
    timeToLogout: logoutDesicionTimeSeconds
  }

  componentDidMount = () => {
    const { user } = this.props

    timerMinutes &&
    get(user, 'access_token') &&
    this.setState({
      interval: this.startInterval(timerMinutes)
    })
  }

  componentWillReceiveProps = nextProps => {
    const isUserNewlyLoggedIn =
      !get(this.props, 'user.access_token') &&
      get(nextProps, 'user.access_token')

    if (isUserNewlyLoggedIn) {
      this.setState({
        interval: this.startInterval(timerMinutes)
      })
    }
  }

  componentDidUpdate = prevProps => {
    const isUserNewlyLoggedOut =
      get(prevProps, 'user.access_token') &&
      !get(this.props, 'user.access_token') &&
      this.state.interval

    if (isUserNewlyLoggedOut) {
      clearInterval(this.state.interval)
      console.log('Activity monitor stopped!')
    }
  }

  startInterval = logoutAfter => {
    activityMonitorStorage.resetLastActivity()
    console.log('Activity monitor initialized', logoutAfter)
    const logoutInSeconds = logoutAfter * 60
    const intervalPeriod = 30000

    return setInterval(async() => {
      const lastActivity = moment(await activityMonitorStorage.getLastActivity())

      if (lastActivity && lastActivity.isValid()) {
        if (moment().diff(lastActivity, 'seconds', true) > logoutInSeconds) {
            clearInterval(this.state.interval)
            console.log('User inactive!')

            this.setState({
              displayWarning: true,
              logoutInterval: this.startLogoutIntervaL()
            })
          }
        }
    }, intervalPeriod)
  }

  startLogoutIntervaL = () => {
    return setInterval(() => {
      this.setState({
        timeToLogout: this.state.timeToLogout - 1
      })

      if (this.state.timeToLogout === 0) {
        this.handleLogout()
      }
    }, 1000)
  }

  handleReinit = () => {
    clearInterval(this.state.logoutInterval)

    this.setState({
      displayWarning: false,
      interval: this.startInterval(timerMinutes),
      timeToLogout: logoutDesicionTimeSeconds
    })
  }

  handleLogout = () => {
    this.setState(
      {
        displayWarning: false,
        timeToLogout: logoutDesicionTimeSeconds
      },
      () => {
        clearInterval(this.state.logoutInterval)

        this.props.push({
          pathname: `${config.publicPath}/logout`,
          state: {
            inactivity: true,
            reason: 'You have been logged out due to inactivity',
            reasonIntlKey: 'moduleTitle.you_have_been_logged_out_due_to_inactivity'
          }
        })
      }
    )
  }

  render() {
    return (
      <div>
        {this.state.displayWarning
          ? <Popup>
            <p>
              <FormattedMessage
                id='label.you_are_going_to_be_logged_out'
                defaultMessage="You're going to be logged out due to inactivity."
              />
            </p>
            <div className='text--right'>
              <Button secondary onClick={this.handleReinit}>
                <FormattedMessage
                  id='button.stay_signed_in'
                  defaultMessage='Stay signed in'
                />
                {' '}
                ({this.state.timeToLogout})
              </Button>
            </div>
          </Popup>
          : null}
      </div>
    )
  }
}

export default enhance(ActivityMonitor)
